import columns from './detection/columns.json';
import common from './detection/common.json';
import statuses from './detection/statuses.json';

const en = {
  ...common,
  columns,
  statuses,
};

export default en;
